"use strict"; // Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0

var _classCallCheck = require("/home/runner/work/merkle-express/merkle-express/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/merkle-express/merkle-express/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScopedLocalStorage = void 0;

var ScopedLocalStorage = /*#__PURE__*/function () {
  function ScopedLocalStorage(scope) {
    _classCallCheck(this, ScopedLocalStorage);

    this.scope = scope;
  }

  _createClass(ScopedLocalStorage, [{
    key: "setItem",
    value: function setItem(key, value) {
      localStorage.setItem(this.scopedKey(key), value);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return localStorage.getItem(this.scopedKey(key));
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      localStorage.removeItem(this.scopedKey(key));
    }
  }, {
    key: "clear",
    value: function clear() {
      var prefix = this.scopedKey("");
      var keysToRemove = [];

      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);

        if (typeof key === "string" && key.startsWith(prefix)) {
          keysToRemove.push(key);
        }
      }

      keysToRemove.forEach(function (key) {
        return localStorage.removeItem(key);
      });
    }
  }, {
    key: "scopedKey",
    value: function scopedKey(key) {
      return "".concat(this.scope, ":").concat(key);
    }
  }]);

  return ScopedLocalStorage;
}();

exports.ScopedLocalStorage = ScopedLocalStorage;